// extracted by mini-css-extract-plugin
export default {"loaderContainer":"MainLoader_loaderContainer__gtNWE","progressBar":"MainLoader_progressBar__fEmlG","moveBackAndForth":"MainLoader_moveBackAndForth__jny8a"};